// src/components/common/PermissionButton.js
import React from "react";
import { Link } from "react-router-dom";
const PermissionButton = ({
  hasPermission = false,
  to,
  onClick,
  icon: Icon,
  faIcon,
  text,
  onlyIcon = false,
  style = {},
  className = "inline-flex items-center text-sm rounded-md transition-colors",
  enabledClass = "bg-[#137e81] hover:bg-green-700 text-white",
}) => {
  if (!hasPermission) {
    return null;
  }

  const buttonContent = (
    <>
      {Icon && <Icon size={16} />}
      {faIcon && <i className={faIcon}></i>}
      {!onlyIcon && text}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={`${className} ${enabledClass}`} style={style} >
        {buttonContent}
      </Link>
    );
  }
  return (
    <button
      onClick={onClick}
      className={`${className} ${enabledClass}`}
      style={style}
    >
      {buttonContent}
    </button>
  );
};

export default PermissionButton;
